import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ContentContainer/ContentContainer.css';

export const prototypeName = 'g1AD6aQdnjI3pO06NX9Zs5yVV2wrkaFG0M3MGy2MUaO5V3jaNPIR13ePv245hMZ0oyx19NCGvQLw3oj';
export {styles};